/**
 * TODO: DELETE THIS FILE WHEN FEATURE FLAG IS FULLY ROLLED OUT
 * This wrapper is only used to conditionally render JobDetails or RunHistoryLegacy
 * based on the enableWarehouseSizeRecommendation feature flag.
 * Once the feature is fully rolled out, replace all usages with JobDetails directly.
 */

import { useAppState } from "@/modules/app/useAppContext";
import { JobDetails } from "./JobDetails";
import { RunHistoryLegacy } from "./RunHistoryLegacy";

export const JobDetailsWrapper = () => {
  const { enableWarehouseSizeRecommendation } = useAppState();
  return enableWarehouseSizeRecommendation ? <JobDetails /> : <RunHistoryLegacy />;
};
